// project import
import Auth from "layouts/Auth";
import CheckInForm from "views/admin/CheckInForm";
import ChangePassword from "views/auth/ChangePassword";
import EmailVerify from "views/auth/EmailVerify";
import FirstLoginOTP from "views/auth/FirstLoginOTP";
import FirstLoginSetPassword from "views/auth/FirstLoginSetPassword";
import Forgot from "views/auth/Forgot";
import Login from "views/auth/Login.js";
import OrganizationDeleted from "views/auth/OrganizationDeleted";
import SelectOrganization from "views/auth/SelectOrganization";
import Register from "views/auth/Register.js";
import ResetPassword from "views/auth/ResetPassword copy";
import EmployeeClockIn from "views/public/EmployeeClockIn";
import DocumentSigningPage from "views/public/DocumentSigningPage";
import DocumentUploadPortal from "views/public/DocumentUploadPortal";
import MaraSignaturePage from "views/public/MaraSignaturePage";

// render - login

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: "/",
  element: <Auth />,
  children: [
    {
      path: "",
      element: <Login />,
    },
    {
      path: "login",
      element: <Login />,
    },
    {
      path: "register",
      element: <Register />,
    },
    {
      path: "forgot",
      element: <Forgot />,
    },
    {
      path: "reset/password/:token",
      element: <ResetPassword />,
    },
    {
      path: "change/password",
      element: <ChangePassword />,
    },
    {
      path: "email/verify/",
      element: <EmailVerify />,
    },
    {
      path: "email/verify-otp",
      element: <FirstLoginOTP />,
    },
    {
      path: "first-login/set-password",
      element: <FirstLoginSetPassword />,
    },
    {
      path: "select-organization",
      element: <SelectOrganization />,
    },
    {
      path: "organization-deleted",
      element: <OrganizationDeleted />,
    },
    {
      path: "employee/clock-in",
      element: <EmployeeClockIn />,
    },
    {
      path: "public/document-sign/:publicToken",
      element: <DocumentSigningPage />,
    },
    {
      path: "public/document-upload/:token",
      element: <DocumentUploadPortal />,
    },
    {
      path: "public/mara-signature/:publicToken",
      element: <MaraSignaturePage />,
    },
  ],
};

export default LoginRoutes;
// "tailwindcss": "2.0.4"
